import React from "react";
import Trial from "../../sections/Bookfreetrial/Trial";
import EOOSCourses from "../../sections/EOOSCourses/EOOSCourses";
import Footer from "../../sections/Footer/Footer";
import Header from "../../sections/Header/Header";
import TitlepicCourses from "../../sections/TitleBgCourses/TitlepicCourses/TitlepicCourses";
const Courses = () => {
  return (
    <div>
      <Header />
      <TitlepicCourses />
      <EOOSCourses />
      <Trial />
      <Footer />
    </div>
  );
};
export default Courses;
